import React from "react"
import styled from "styled-components"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import BlockContainer from "../BlockContainer"
import {
  getActiveEnv,
  getCurrentVersion,
} from "../../../services/environmentHelper"
// import LogoIcon from "../../../resources/img/logo-black.svg"
import LogoIcon from "../../../resources/img/logo-2025.svg"
import KlaviyoSubscribe from "../KlaviyoSubscribe"
import breakpoints from "../../../styles/breakpoints"
import FooterSignup from "./FooterSignup"
import BcorpCertified from "../../../resources/img/footer/certified_b_corp.png"
import { getBespokeLink } from "../../../services/links"
import FooterLinks from "./FooterLinks"
import { withTranslation } from "gatsby-plugin-react-i18next"

const DesktopFooterContainer = styled.div`
  display: none;
  background: ${colors.globalgreen};

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`

const FooterContainer = styled.div`
  background: rgba(209, 193, 182, 0.5);
  padding: 94px 0 30px;
`

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;

  @media (min-width: ${breakpoints.xl}) {
    flex-wrap: nowrap;
    gap: 80px;
  }

  @media (min-width: ${breakpoints.xl}) {
    gap: 140px;
  }
`

const LogoMenusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 40px;
  align-self: flex-start;

  @media (min-width: ${breakpoints.xl}) {
    flex-wrap: nowrap;
    gap: 80px;
  }

  @media (min-width: ${breakpoints.xl}) {
    gap: 140px;
  }
`

const Logo = styled.img`
  width: 144px;
  height: min-content;
`

const Menus = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  justify-content: center;
  white-space: nowrap;
  align-items: flex-start;

  @media (min-width: ${breakpoints.xxl}) {
    gap: 80px;
  }
`

const Column = styled.div`
  ${fonts.ivyPrestoLight};
  color: ${colors.trueBlack};
  font-size: 12px;
  line-height: 1.6;
  letter-spacing: 1px;
  flex: 1;
  display: grid;
  gap: 10px;

  a {
    color: inherit;
    text-decoration: none;
    text-transform: lowercase;

    &:hover {
      text-decoration: underline;
    }
  }

  button {
    color: inherit;
    text-decoration: none;
    text-transform: lowercase;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    text-align: left;
    cursor: pointer;
    letter-spacing: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
`

const SignupContainer = styled.div`
  min-width: 278px;
`

const LocationContainer = styled.div`
  ${fonts.ivyStyleRegular};
  font-size: 10px;
  line-height: 1.6;
  color: ${colors.mediumTextGrey};
  background: ${colors.white};
  margin-top: 80px;
  padding: 7px 0;
`

const LocationContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  align-items: center;
`

const Location = styled.button`
  ${fonts.ivyStyleRegular};
  padding: 0;
  background: transparent;
  border: none;
  text-decoration: underline;
  font-size: 10px;
  line-height: 1.4;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`

const LinkContents = styled.div`
  display: flex;
  align-items: center;
  gap: 39px;
`

const SocialLinks = styled.div`
  display: flex;
  gap: 12px;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

const DesktopFooter = ({ handlePopup, t }) => {
  const currentVersion = getCurrentVersion()
  const activeEnv = getActiveEnv()

  const menuList = [
    [
      { name: t("footer.link.faqs"), link: "/faq/" },
      { name: t("footer.link.shipping_returns"), link: "/faq/" },
      { name: t("footer.link.warranty"), link: "/faq/" },
      { name: t("footer.link.contact"), link: "/contact/" },
    ],
    [
      { name: t("footer.link.store"), link: "/london-store" },
      { name: t("footer.link.book_an_appointment"), link: getBespokeLink() },
      { name: t("footer.link.find_us"), link: "/contact/" },
      {
        name: t("footer.link.lab_grown_diamonds"),
        link:
          activeEnv === "us" || activeEnv === "fr"
            ? "/learn/lab-grown-diamonds/"
            : "https://kimai.com/learn/lab-grown-diamonds/",
        isExternal: activeEnv === "us" || activeEnv === "fr" ? false : true,
      },
    ],
    [
      {
        name: t("footer.link.engagement_101"),
        link:
          activeEnv === "us" || activeEnv === "fr"
            ? "/learn/diamond-buying-guide"
            : "https://kimai.com/learn/diamond-buying-guide",
        isExternal: activeEnv === "us" || activeEnv === "fr" ? false : true,
      },
      { name: t("footer.tc"), link: "/terms-and-conditions/" },
    ],
  ]

  const socialLinks = [
    {
      name: "Instagram",
      link: "https://www.instagram.com/kimai_jewelry",
    },
    {
      name: "Facebook",
      link: "https://www.facebook.com/kimai.co",
    },
    {
      name: "Pinterest",
      link: "https://pin.it/5dPhxkW",
    },
  ]

  const handleCookieClick = () => {
    if (
      typeof window !== "undefined" &&
      typeof window.OneTrust !== "undefined"
    ) {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  return (
    <DesktopFooterContainer>
      <FooterContainer>
        <BlockContainer>
          <FooterContent>
            <LogoMenusContainer>
              <Logo src={LogoIcon} alt="Kimaï" />
              <Menus>
                {menuList.map((list, index) => {
                  return (
                    <Column key={index}>
                      <FooterLinks list={list} />
                      {/*OneTrust Cookies Settings button start*/}
                      {index === 2 && (
                        <button onClick={() => handleCookieClick()}>
                          {t("footer.cp")}
                        </button>
                      )}
                      {/*OneTrust Cookies Settings button end*/}
                    </Column>
                  )
                })}
              </Menus>
            </LogoMenusContainer>
            <SignupContainer>
              <KlaviyoSubscribe>
                <FooterSignup />
              </KlaviyoSubscribe>
            </SignupContainer>
          </FooterContent>
        </BlockContainer>
        <LocationContainer>
          <BlockContainer>
            <LocationContent>
              <div>
                {t("header.shipping_to")}{" "}
                <Location onClick={() => handlePopup(true)}>
                  {currentVersion.name} ({currentVersion.currency})
                </Location>
              </div>
              <LinkContents>
                <SocialLinks>
                  {socialLinks.map((social, index) => {
                    return (
                      <a
                        href={social.link}
                        key={index}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {social.name}
                      </a>
                    )
                  })}
                </SocialLinks>
                <img
                  src={BcorpCertified}
                  alt="Certified B Corporation"
                  width="45"
                  height="59"
                />
              </LinkContents>
            </LocationContent>
          </BlockContainer>
        </LocationContainer>
      </FooterContainer>
    </DesktopFooterContainer>
  )
}

export default withTranslation()(DesktopFooter)
